/**
 * 渲染器注册表：把现有 React 函数组件渲染器登记到 BaseWidget 体系。
 *
 * 现有渲染器是 React 函数组件（runtime-renderer.tsx），Widget 类作为
 * 元数据/行为载体通过 getPageView 引用它们，而非强制改写组件写法（最小侵入）。
 * 独立成模块以规避 runtime-renderer <-> widgets 的循环导入。
 */
import * as React from "react";

import type { ComponentNode } from "@shared/types";

export interface WidgetRendererProps {
  node?: ComponentNode;
  props?: Record<string, unknown>;
  children?: React.ReactNode;
  [key: string]: unknown;
}

export type WidgetRenderer = React.FC<WidgetRendererProps>;

const rendererRegistry: Record<string, WidgetRenderer> = {};

/** 注册组件渲染器（runtime-renderer.tsx 模块加载时调用） */
export function registerRenderer(type: string, renderer: WidgetRenderer): void {
  rendererRegistry[type] = renderer;
}

export function getRenderer(type: string): WidgetRenderer | undefined {
  return rendererRegistry[type];
}

export function hasRenderer(type: string): boolean {
  return type in rendererRegistry;
}
